import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MarkdownService } from 'ngx-markdown';
import { BehaviorSubject } from 'rxjs';
import { DocumentsHttpService } from 'src/app/services/httpServices/documentsHttpService/documents-http.service';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
})
export class ChangelogComponent implements OnInit {
  public changelogContent: string | undefined;
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public showNoData = false;
  public activePageTitleLabelPath: string;

  constructor(
    private readonly _documentsHttpService: DocumentsHttpService,
    private readonly _markdownService: MarkdownService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  ngOnInit(): void {
    this._fetchChangelog();
  }

  private _fetchChangelog(): void {
    this._documentsHttpService.getChangelogFile().subscribe(
      (data: string) => {
        const parsedData = this._markdownService.parse(data);

        if (parsedData instanceof Promise) {
          parsedData.then((result: string) => {
            this.changelogContent = result;
            this._updateView();
          });
        } else {
          this.changelogContent = parsedData;
          this._updateView();
        }
      },
      (error: HttpErrorResponse) => {
        this.showNoData = true;
        this.isLoading.next(false);
        this._httpErrorHandlerService.handle(error);
      }
    );
  }

  private _updateView(): void {
    this.showNoData = this.changelogContent == undefined;
    this.activePageTitleLabelPath = 'menu.changelogPage';
    this.isLoading.next(false);
  }
}
